import {Trans, useTranslation} from "react-i18next";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import React, {useMemo} from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {usePriceList} from "../../../../Providers/PriceListProvider";
import {formatCurrency} from "../../../../../utils";

const useStyles = makeStyles((theme) => ({
    priceCell: {
        //  textAlign: 'right'
    },
    oldPrice: {
        textDecoration: 'line-through'
    },
    productTable: {
        '& > thead > tr > th': {
            backgroundColor: '#E4E4E4',
            textAlign: 'center',
            fontWeight: 'normal',
            padding: theme.spacing(1)
        },
        '& > tbody > tr > td': {
            textAlign: 'center'
        }
    },
    headerContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    dialogContent: {
        paddingLeft: 0,
        paddingRight: 0,
        '& h4': {
            textAlign: 'center',
            marginBottom: theme.spacing(1),
            marginTop: theme.spacing(3),
            width: '80%'
        }
    }
}));

export default ({open, handleClose}) => {
    const classes = useStyles();
    const [t] = useTranslation();
    const { getPrintFormats } = usePriceList();

    const products = useMemo(() => {
        const products = getPrintFormats();
        return products;
    }, [])

    if (!open) {
        return null;
    }

    return <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
        <DialogTitle id="simple-dialog-title">
            <Trans>Paper copies</Trans>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
            {products.map ( (product) => {
                return <ProductPrice key={product.uuid} product={product} />
            })}
        </DialogContent>
        <DialogActions>
            <Button onClick={handleClose} color="primary" autoFocus>
                <Trans>Ok</Trans>
            </Button>
        </DialogActions>
    </Dialog>
}


const ProductPrice = ({product}) => {
    const [t] = useTranslation();
    const classes = useStyles();
    const { productHasCampaign } = usePriceList();

    const hasCampaign = useMemo(() => {
        return productHasCampaign(product);
    }, [product])


    const prices = product.productprices.reduce( (prices, price) => {
        if (prices.length > 0) {
            prices[prices.length-1].quantityTo = price.quantity-1;
        }

        let campaignPrice = 0;
        if (hasCampaign) {
            campaignPrice = price.campaignprice
        }

        prices.push({
            quantityFrom: price.quantity,
            quantityTo: 0,
            price: price.price,
            campaignPrice: campaignPrice
        })
        return prices;
    }, []);

    let productName = product.name;

    return <>
        <div className={classes.headerContainer}>
            <h4>{productName}</h4>
        </div>
        <Table className={classes.productTable}>
            <TableHead>
                <TableRow>
                    <TableCell><Trans>Quantity</Trans></TableCell>
                    <TableCell><Trans>Price/pcs</Trans></TableCell>
                    {hasCampaign && <TableCell><Trans>Campaign price</Trans></TableCell>}
                </TableRow>
            </TableHead>
            <TableBody>
                {prices.map((pp, index) => {
                    console.log('Product price', pp)
                    let qtyString = pp.quantityFrom;
                    if (pp.quantityTo) {
                        qtyString += '-' + pp.quantityTo;
                    } else {
                        qtyString += '+';
                    }
                    return <TableRow key={index}>
                        <TableCell>{t("%s pcs", {
                            postProcess: 'sprintf',
                            sprintf: [qtyString]
                        })}</TableCell>
                        <TableCell  className={hasCampaign ? classes.oldPrice : ''}>{formatCurrency(pp.price)}</TableCell>
                        {hasCampaign &&
                        <TableCell>{formatCurrency(pp.campaignPrice)}</TableCell>
                        }
                    </TableRow>
                })}
            </TableBody>
        </Table>
    </>
}